export default __webpack_public_path__ + "static/media/LogoFooter.2c959737.svg";